import { render, staticRenderFns } from "./school_list.vue?vue&type=template&id=060f13ee&scoped=true"
import script from "./school_list.vue?vue&type=script&lang=js"
export * from "./school_list.vue?vue&type=script&lang=js"
import style0 from "./school_list.vue?vue&type=style&index=0&id=060f13ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f13ee",
  null
  
)

export default component.exports